import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { inputClass } from './AuthLayout';

/** Password field with a show/hide toggle. Accepts standard input props. */
function PasswordInput({ value, onChange, placeholder, autoComplete = 'current-password', required = true }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        className={`${inputClass} pr-12`}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? 'Hide password' : 'Show password'}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-fg-muted hover:text-fg transition-colors"
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}

export default PasswordInput;
